<script setup lang="ts">
import type { CmsElementTabNavigation } from '@/composables/useCustom';

const props = defineProps<{
  content: CmsElementTabNavigation;
}>();

const { content } = props;
const { data } = content;

const links = computed(() => data?.Links || []);

</script>
<template>
  <div v-if="links.length" class="links-wrap px-4">
    <div class="container mx-auto relative pt-12 pb-12">
      <div class="wrap">
        <ul class="flex items-center gap-3 sm:gap-6 flex-wrap">
          <li v-for="(link, index) in links" :key="index" class="flex items-center">
            <SharedButton
              v-if="link.button"
              :button="link.button"
              class="chips"
              activeClass="chips-active"
            >
            </SharedButton>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
